import React from 'react'
import * as Yup from 'yup'
import {FormLayout, Icon, Modal} from '@therms/atalaya'
import {Formik} from 'formik'
import {FormikToggleSwitch} from '@therms/react-modules'
import {IoMdDownload} from 'react-icons/io'

const ValidationSchema = Yup.object().shape({
  showEventsRefs: Yup.boolean(),
  showInternalContent: Yup.boolean(),
  showLocationsRefs: Yup.boolean(),
  showLogEntriesRefs: Yup.boolean(),
  showRecordsRefs: Yup.boolean(),
  showReportsRefs: Yup.boolean(),
  showUsersRefs: Yup.boolean(),
  withRefHistory: Yup.boolean(),
})

type Values = {
  showInternalContent: boolean
  showEventsRefs: boolean
  showLocationsRefs: boolean
  showLogEntriesRefs: boolean
  showRecordsRefs: boolean
  showReportsRefs: boolean
  showUsersRefs: boolean
  withRefHistory?: boolean
}

const initialValues: Values = {
  showEventsRefs: false,
  showInternalContent: false,
  showLocationsRefs: false,
  showLogEntriesRefs: false,
  showRecordsRefs: false,
  showReportsRefs: false,
  showUsersRefs: false,
  withRefHistory: false,
}

interface PickReportRefsModalProps {
  closeHandler: () => void
  onDownload: (values: Values) => void
}

function PickReportRefsModal({
  closeHandler,
  onDownload,
}: PickReportRefsModalProps) {
  return (
    <Modal
      closeHandler={closeHandler}
      escPressClose
      header="Download Report"
      outsideClickClose
      width="sm"
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onDownload(values)}
        ValidationSchema={ValidationSchema}
      >
        {({handleSubmit, values}) => (
          <FormLayout space="xs">
            <div className="font-bold">PDF Details</div>

            <FormikToggleSwitch
              active={values.showInternalContent}
              name="showInternalContent"
              label={
                <div className="text-color">Include Internal Content?</div>
              }
            />

            <div className="mt-base">
              <div className="font-bold">References</div>

              <FormikToggleSwitch
                active={values.withRefHistory}
                name="withRefHistory"
                label={
                  <div className="text-color">
                    Include the Reference History?
                  </div>
                }
                subText="Include a timestamped list of all references for this Event."
              />

              <FormikToggleSwitch
                active={values.showEventsRefs}
                name="showEventsRefs"
                label={
                  <div className="text-color">Include Event References?</div>
                }
              />

              <FormikToggleSwitch
                active={values.showLocationsRefs}
                name="showLocationsRefs"
                label={
                  <div className="text-color">Include Location References?</div>
                }
              />

              <FormikToggleSwitch
                active={values.showLogEntriesRefs}
                name="showLogEntriesRefs"
                label={
                  <div className="text-color">
                    Include Log Entries References?
                  </div>
                }
              />

              <FormikToggleSwitch
                active={values.showRecordsRefs}
                name="showRecordsRefs"
                label={
                  <div className="text-color">Include Record References?</div>
                }
              />

              <FormikToggleSwitch
                active={values.showReportsRefs}
                name="showReportsRefs"
                label={
                  <div className="text-color">Include Report References?</div>
                }
              />

              <FormikToggleSwitch
                active={values.showUsersRefs}
                name="showUsersRefs"
                label={
                  <div className="text-color">Include User References?</div>
                }
              />
            </div>

            <div className="mt-sm">
              <FormLayout.Controls
                onSubmit={handleSubmit}
                submitLabel={
                  <>
                    <Icon Icon={IoMdDownload} className="mr-xxs" />
                    Download
                  </>
                }
              />
            </div>
          </FormLayout>
        )}
      </Formik>
    </Modal>
  )
}

export {PickReportRefsModal}
